module.exports = __webpack_public_path__ + "img/Susanne_Steuerberaterin_pic.93d24d0d.jpeg";